export const WA_NUMBER = "62895400706846"; // 0895400706846

export const bankInfo = {
  bank: "BCA",
  name: "Hari Hermawan",
  number: "0953311647",
};

export const heroData = {
  badge: "Hiasan Dinding Terbaik #1",
  titleTop: "Setiap Dinding",
  titleBottom: "Punya Cerita.",
  subtitle:
    "Ubah dinding polosmu jadi galeri pribadi. Koleksi hiasan dinding kurasi terbaik \u2014 dari wall art, cermin rotan, sampai neon sign custom.",
  image: "https://images.unsplash.com/photo-1513519245088-0e12902e5a38",
  cta: "Mulai Belanja",
};

export const storyData = {
  eyebrow: "Cerita Kami",
  title: "Berawal dari Dinding yang Kosong",
  lead: "Tahun 2019, kami berdiri di sebuah kamar kos kecil dengan dinding putih polos yang terasa... hampa.",
  paragraphs: [
    "Kami percaya dinding bukan sekadar pembatas ruang. Ia adalah kanvas tempat cerita hidupmu dipajang \u2014 foto perjalanan pertama, lukisan yang bikin tenang, atau cermin yang menyambutmu setiap pagi.",
    "Dari keyakinan itu ruangrasa lahir. Kami mengkurasi dan membuat hiasan dinding yang tidak hanya indah dipandang, tapi juga punya rasa \u2014 dibuat oleh pengrajin lokal, dengan material pilihan, dan detail yang dikerjakan sepenuh hati.",
    "Hari ini, lebih dari 8.000 dinding di seluruh Indonesia telah bercerita bersama ruangrasa. Sekarang, giliran dindingmu.",
  ],
  milestones: [
    {
      icon: "Sprout",
      year: "2019",
      title: "Dimulai dari Kamar Kos",
      desc: "50 pesanan pertama, semuanya dikemas dengan tangan di kamar 3x3 meter.",
    },
    {
      icon: "Hammer",
      year: "2022",
      title: "Bermitra Pengrajin Lokal",
      desc: "Berkolaborasi dengan 20+ pengrajin rotan, kayu, dan kanvas di Jawa & Bali.",
    },
    {
      icon: "Heart",
      year: "2026",
      title: "8.000+ Dinding Bercerita",
      desc: "Menjadi toko hiasan dinding dengan rating 4.9 dari ribuan pelanggan.",
    },
  ],
  quote: "Ruang yang kamu tempati, menentukan rasa yang kamu bawa pulang.",
  image: "https://images.unsplash.com/photo-1729867979930-a34b565e12e9",
};

export const whyItems = [
  {
    icon: "BadgeCheck",
    title: "Kurasi Berkualitas",
    desc: "Setiap produk melewati kurasi ketat: material, finishing, dan ketahanan warna dicek satu per satu.",
    color: "#DFF0EA",
  },
  {
    icon: "Truck",
    title: "Packing Super Aman",
    desc: "Dikemas bubble wrap berlapis dan kardus tebal. Rusak di jalan? Kami ganti baru tanpa ribet.",
    color: "#E3F2FD",
  },
  {
    icon: "Wallet",
    title: "Harga Jujur",
    desc: "Langsung dari pengrajin tanpa markup berlebihan. Kualitas galeri, harga tetap bersahabat.",
    color: "#FFF8E1",
  },
  {
    icon: "HeartHandshake",
    title: "CS Super Ramah",
    desc: "Tim kami siap membantu 7 hari seminggu. Gratis konsultasi pemilihan hiasan untuk ruanganmu.",
    color: "#FCE4EC",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Siti Rahmawati",
    role: "Ibu Rumah Tangga, Bandung",
    avatar: "https://images.pexels.com/photos/698532/pexels-photo-698532.jpeg",
    stars: 5,
    text: "Poster botanical-nya cantik banget, frame kayunya rapi. Dinding ruang tamuku langsung hidup!",
  },
  {
    id: 2,
    name: "Andi Pratama",
    role: "Pemilik Coffee Shop, Yogyakarta",
    avatar:
      "https://images.unsplash.com/photo-1518725522904-4b3939358342",
    stars: 5,
    text: "Order neon sign custom nama cafe-ku, hasilnya rapi banget dan terangnya pas. Admin fast respon via WhatsApp.",
  },
  {
    id: 3,
    name: "Dewi Lestari",
    role: "Mahasiswa, Surabaya",
    avatar:
      "https://images.pexels.com/photos/20418916/pexels-photo-20418916.jpeg",
    stars: 5,
    text: "Cermin rotannya estetik parah, packing kayu super aman sampai Surabaya. Nggak nyesel beli di sini!",
  },
  {
    id: 4,
    name: "Budi Santoso",
    role: "Karyawan Swasta, Jakarta",
    avatar:
      "https://images.unsplash.com/photo-1757744705465-ea08b0ddc38a",
    stars: 5,
    text: "Makrame-nya handmade asli, detail simpulnya halus. Langsung jadi focal point di kamar dan sering masuk konten.",
  },
];

export const stats = [
  { value: "12K+", label: "Produk Terjual" },
  { value: "4.9", label: "Rating Toko" },
  { value: "8K+", label: "Dinding Bercerita" },
];

export const faq = [
  {
    q: "Berapa lama pesanan diproses dan dikirim?",
    a: "Pesanan ready stock diproses di hari yang sama (sebelum jam 15.00 WIB) dan langsung dikirim. Untuk produk custom seperti neon sign, pengerjaan 3\u20135 hari kerja.",
  },
  {
    q: "Apakah aman dikirim ke luar kota?",
    a: "Sangat aman. Semua produk dikemas bubble wrap berlapis dan kardus tebal. Untuk cermin & kanvas besar kami tambahkan proteksi kayu. Rusak di perjalanan kami ganti baru.",
  },
  {
    q: "Metode pembayaran apa saja yang tersedia?",
    a: "Saat ini pembayaran melalui transfer bank BCA a.n. Hari Hermawan. Setelah transfer, cukup konfirmasi via WhatsApp dan pesananmu langsung kami proses.",
  },
  {
    q: "Bisakah pesan hiasan dinding custom?",
    a: "Bisa! Kami melayani neon sign, wall art, dan makrame custom sesuai ukuran & desainmu. Hubungi admin via WhatsApp untuk konsultasi gratis.",
  },
  {
    q: "Apakah ada garansi produk?",
    a: "Ada. Kami memberi garansi produk sampai di tanganmu dalam kondisi baik. Jika ada cacat produksi atau kerusakan pengiriman, kami ganti tanpa ribet.",
  },
];

export const formatRupiah = (num) =>
  "Rp " + (num || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

export const formatSold = (num) => {
  const n = num || 0;
  if (n >= 10000) return `${Math.floor(n / 1000)}rb+`;
  if (n >= 1000) return `${(n / 1000).toFixed(1).replace(".0", "").replace(".", ",")}rb`;
  return `${n}`;
};
